// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote___v4fY","modalFooterButton":"ModalNotes_modalFooterButton__35S2T"};